// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h1,
h2,
h3,
h4,
h5,
h6 {
  margin-bottom: 0px !important;
  cursor: pointer;
}

.loader {
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 1;
}

.notification-count {
  color: red !important;
  font-weight: bold;
}

.loader .ant-spin-spinning {
  position: static;
  display: flex;
  opacity: 1;
}

a {
  text-decoration: none !important;
}

.body_content {
  margin: auto;
}

.layout_content_body {
  margin-top: 60px;
}

.ant-drawer-mask {
  background: none;
}

.main_container {
  padding: 0 16px;
  margin: auto;
}

.maps__modal__popup .ant-modal-body {
  height: 550px;
}

.collection-header {
  color: rgb(0, 51, 153);
  background-color: rgb(235, 239, 247);
  padding: 1%;
  font-size: 20px;
  font-weight: 500;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.heading-collection {
  padding: 1% 1%;
  border-bottom: 1px solid lightgray;
  color: #003399;
  font-size: 16px;
  display: flex;
  font-weight: 400;
  background: #D2E1FF;
  justify-content: space-between;
  align-items: center;
}

.heading-collection1 {
  padding: 3% 1%;
  border-bottom: 1px solid lightgray;
  color: #003399;
  font-size: 16px;
  font-weight: 400;
  background: #D2E1FF;
}

.column-collection {
  padding: 1% 0%;
}

.select-collection .ant-select-selector {
  background: transparent !important;
}

.collection-title {
  color: rgb(155, 148, 148);
  font-size: 12px;
}

.collection-content {
  font-weight: 500;
  text-transform: capitalize;
}

.radio-product .ant-radio-button-wrapper {
  margin-right: 10px;
  background-color: transparent;
  color: #28B1FF;
  border: 1px solid #28B1FF;
  border-start-start-radius: 15px;
  border-start-end-radius: 15px;
  border-end-start-radius: 15px;
  border-end-end-radius: 15px;
}

.radio-product .ant-radio-button-wrapper:not(:first-child)::before {
  display: none;
}

.radio-product .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
  color: white !important;
  border: 1px solid white !important;
  background-color: #28B1FF !important;
}

.radio-product .ant-wave-target {
  display: none;
}

.radio-product1 {
  display: inline-grid;
  width: 100%;
}

.product-div-3 :where(.css-dev-only-do-not-override-42nv3w).ant-radio-group {
  display: flex;
  inline-size: max-content;
}

.product-div-1 {
  background-color: #003399;
  min-height: 10rem;
}

.product-div-1 .breadcrumb {
  background-color: #003399;
  margin-bottom: 0rem;
  padding: 0rem 1rem;
}

.product-div-2 {
  font-size: 26px;
  color: white;
  font-weight: 500;
  padding: 10px 15px;
}

.product-div-3 {
  padding: 0px 10px;
  overflow-x: scroll;
}

.title-subproduct {
  color: #28B1FF;
  font-size: 16px;
  font-weight: 500;
  padding: 10px 0px;
}

.card-title-product .ant-card-body {
  padding: 0px;
}

.title-card-product {
  padding: 8px;
  background-color: #D2E1FF;
  color: #003399;
  font-weight: 500;
  font-size: 18px;
}

.title-card-sub-product {
  padding: 8px;
  border-left: 1px solid #003399;
  color: #003399;
  font-weight: 500;
  font-size: 18px;
  background-color: #f5f8fd;
}

.video-container {
  position: relative;
}

.share-link {
  position: absolute;
  left: -20px;
  z-index: 1;
  top: -3px;
  background-color: #28B1FF;
  color: white;
  border-radius: 60px;
  padding: 5px;
}

.arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 30px;
  height: 35px;
  background-color: transparent;
  color: #003399;
  font-size: 24px;
  text-align: center;
  line-height: 30px;
  cursor: pointer;
}

.left-arrow {
  left: 0;
  z-index: 1;
}

.right-arrow {
  right: 0;
  z-index: 1;
}

.video-wrapper {
  position: relative;
}

.upload-document-width {
  width: 60%;
}

@media screen and (max-width:600px) {
  .upload-document-width {
    width: 100%;
  }

  .video-width {
    margin: 0% !important;
  }

  .table-document-head .ant-table-thead {
    display: none;
  }

  .table-document-head .ant-table-row {
    display: grid;
    width: 95%;
  }
}

@media screen and (min-width:601px) and (max-width:1000px) {
  .upload-document-width {
    width: 100%;
  }
}

.total-value-amount {
  font-size: 20px;
  color: #003399;
  font-weight: 500;
}

.total-value-label {
  font-size: 18px;
  color: darkgray;
  font-weight: 400;
  margin-bottom: 5px;
}

.css-c1eq84-MuiPieArcLabel-root {
  fill: white !important;
  font-size: 18px;
}

.css-1u0lry5-MuiChartsLegend-root {
  display: none;
}

.view-btn {
  color: white;
  background-color: #003399;
  margin-right: 20px;
  width: 75px;
  border-radius: 8px;
}

.modal-footer-disable .ant-modal-footer {
  display: none !important;
}

.row-data-collection {
  display: flex;
  column-gap: 10px;
  justify-content: flex-start;
}

.title-view {
  width: 180px;
  font-size: 18px;
  color: darkgray;
}

.content-view {
  font-size: 18px;
}

.upload-receipt {
  width: 50%;
}

.upload-receipt .filetypetitle {
  font-size: 10px;
  color: darkgray !important;
}

.upload-receipt .anticon-upload {
  font-size: 25px;
}

.upload-receipt button {
  width: 225px;
  height: 50px;
  color: #003399;
}

:where(.css-mzwlov).ant-breadcrumb .ant-breadcrumb-separator {
  color: white !important;
}

:where(.css-dev-only-do-not-override-42nv3w).ant-breadcrumb .ant-breadcrumb-separator {
  color: white !important;
}

:where(.css-dev-only-do-not-override-42nv3w).ant-form-item .ant-form-item-label>label {
  padding: 2px;
}

.verify-button-entity {
  color: rgb(75, 214, 75);
  background: transparent;
  font-weight: 500;
  border: none;
  height: 25px;
  display: flex;
  align-items: center;
}

.image-web-document {
  width: 400px;
  height: 400px;
}

:where(.css-dev-only-do-not-override-42nv3w).ant-breadcrumb .ant-breadcrumb-separator {
  color: white !important;
}

:where(.css-17seli4).ant-breadcrumb .ant-breadcrumb-separator {
  color: white !important;
}

.table-wrap-view .ant-table-cell {
  text-wrap: nowrap !important;
}

:where(.css-dev-only-do-not-override-42nv3w).ant-table-wrapper .ant-table-cell,
:where(.css-dev-only-do-not-override-42nv3w).ant-table-wrapper .ant-table-thead>tr>th {
  padding: 8px;
}

.todo-table-content :where(.css-dev-only-do-not-override-42nv3w).ant-table-wrapper .ant-table-cell,
:where(.css-dev-only-do-not-override-42nv3w).ant-table-wrapper .ant-table-thead>tr>th {
  padding: 8px;
  text-wrap: nowrap !important;
}

.todo-table-content .ant-table-thead {
  padding: 8px;
  text-wrap: nowrap !important;
}

.todo-table-content .ant-table-tbody {
  text-wrap: nowrap !important;
}

.existing-collapse .ant-collapse-header {
  border-bottom: 1px solid lightgray;
}

.existing-collapse .ant-collapse-content {
  background-color: white !important;
}

.title-existing-retail {
  color: #003399;
  font-size: 16px;
  margin: 5px 0px;
  font-weight: bold;
}

.button-video {
  background-color: #003399;
  color: white;
  width: 50%;
  border-radius: 10px;
  height: 34px;
}

.button-video1 {
  background-color: white;
  color: #003399 !important;
  border: 1px solid #003399;
  width: 50%;
  border-radius: 10px;
  margin: 0px 5px;
  height: 34px;
}

:where(.css-dev-only-do-not-override-m4timi).ant-modal .ant-modal-content {
  padding: 0px !important;
}

.ant-modal-title {
  color: #003399 !important;
  background-color: #ebeff7 !important;
  padding: 10px !important;
}

.ant-breadcrumb-link {
  color: white !important;
}

:where(.css-dev-only-do-not-override-m4timi).ant-breadcrumb .ant-breadcrumb-separator {
  color: white !important;
}

.ant-modal-content {
  padding: 0px !important;
}

.score-align {
  display: flex;
  align-items: center;
}

/* .ant-tabs-tab {
  background-color: #D2E1FF !important;
} */

.pdfContainer {
  width: 100%;
  height: 500px;
  overflow-y: auto;
}

.customViewer {
  width: 100%;
}

.customCanvas {
  width: 100%;
}

.radio-product1 :where(.css-dev-only-do-not-override-m4timi).ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
  background-color: #ebf1ff !important;
}

.radio-product1 :where(.css-dev-only-do-not-override-m4timi).ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
  border-left: 2px solid #003399 !important;
  border-radius: 0px !important;
  border: none !important;
}

.radio-product1 :where(.css-dev-only-do-not-override-m4timi).ant-radio-button-wrapper {
  border: none !important;
}

.checkmark {
  width: 6rem !important;
  height: 6rem !important;
  margin: 20px;
}

.checkmark__circle {
  stroke: rgb(114, 231, 114)
}

:where(.css-dev-only-do-not-override-m4timi).ant-drawer .ant-drawer-content {
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
}

:where(.css-dev-only-do-not-override-m4timi).ant-drawer .ant-drawer-header {
  background: #ebeff7;
  color: #003399;
}

:where(.css-dev-only-do-not-override-m4timi).ant-drawer .ant-drawer-close {
  color: #003399;
}

:where(.css-dev-only-do-not-override-m4timi).ant-tabs-card.ant-tabs-top>.ant-tabs-nav .ant-tabs-tab,
:where(.css-dev-only-do-not-override-m4timi).ant-tabs-card.ant-tabs-top>div>.ant-tabs-nav .ant-tabs-tab {
  background: #ecf3ff;
  border: 1px solid #bfcdea;
}

.ant-breadcrumb-separator {
  color: white !important;
}


.video-width {
  margin: 0% 35%;
}

input:-webkit-autofill {
  -webkit-transition: background-color 9999s ease-in-out 0s;
  transition: background-color 9999s ease-in-out 0s;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;;;;;;EAME,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,oCAAoC;EACpC,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,cAAc;EACd,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,cAAc;EACd,yBAAyB;EACzB,+BAA+B;EAC/B,6BAA6B;EAC7B,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,8BAA8B;EAC9B,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,SAAS;EACT,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,UAAU;AACZ;;AAEA;EACE,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,UAAU;EACZ;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,yBAAyB;EACzB,UAAU;EACV,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;GAEG;;AAEH;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yCAAyC;EACzC,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE;AACF;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;;AAGA;EACE,cAAc;AAChB;;AAEA;EACE,yDAAiD;EAAjD,iDAAiD;AACnD","sourcesContent":["h1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  margin-bottom: 0px !important;\n  cursor: pointer;\n}\n\n.loader {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  opacity: 1;\n}\n\n.notification-count {\n  color: red !important;\n  font-weight: bold;\n}\n\n.loader .ant-spin-spinning {\n  position: static;\n  display: flex;\n  opacity: 1;\n}\n\na {\n  text-decoration: none !important;\n}\n\n.body_content {\n  margin: auto;\n}\n\n.layout_content_body {\n  margin-top: 60px;\n}\n\n.ant-drawer-mask {\n  background: none;\n}\n\n.main_container {\n  padding: 0 16px;\n  margin: auto;\n}\n\n.maps__modal__popup .ant-modal-body {\n  height: 550px;\n}\n\n.collection-header {\n  color: rgb(0, 51, 153);\n  background-color: rgb(235, 239, 247);\n  padding: 1%;\n  font-size: 20px;\n  font-weight: 500;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n\n.heading-collection {\n  padding: 1% 1%;\n  border-bottom: 1px solid lightgray;\n  color: #003399;\n  font-size: 16px;\n  display: flex;\n  font-weight: 400;\n  background: #D2E1FF;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.heading-collection1 {\n  padding: 3% 1%;\n  border-bottom: 1px solid lightgray;\n  color: #003399;\n  font-size: 16px;\n  font-weight: 400;\n  background: #D2E1FF;\n}\n\n.column-collection {\n  padding: 1% 0%;\n}\n\n.select-collection .ant-select-selector {\n  background: transparent !important;\n}\n\n.collection-title {\n  color: rgb(155, 148, 148);\n  font-size: 12px;\n}\n\n.collection-content {\n  font-weight: 500;\n  text-transform: capitalize;\n}\n\n.radio-product .ant-radio-button-wrapper {\n  margin-right: 10px;\n  background-color: transparent;\n  color: #28B1FF;\n  border: 1px solid #28B1FF;\n  border-start-start-radius: 15px;\n  border-start-end-radius: 15px;\n  border-end-start-radius: 15px;\n  border-end-end-radius: 15px;\n}\n\n.radio-product .ant-radio-button-wrapper:not(:first-child)::before {\n  display: none;\n}\n\n.radio-product .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {\n  color: white !important;\n  border: 1px solid white !important;\n  background-color: #28B1FF !important;\n}\n\n.radio-product .ant-wave-target {\n  display: none;\n}\n\n.radio-product1 {\n  display: inline-grid;\n  width: 100%;\n}\n\n.product-div-3 :where(.css-dev-only-do-not-override-42nv3w).ant-radio-group {\n  display: flex;\n  inline-size: max-content;\n}\n\n.product-div-1 {\n  background-color: #003399;\n  min-height: 10rem;\n}\n\n.product-div-1 .breadcrumb {\n  background-color: #003399;\n  margin-bottom: 0rem;\n  padding: 0rem 1rem;\n}\n\n.product-div-2 {\n  font-size: 26px;\n  color: white;\n  font-weight: 500;\n  padding: 10px 15px;\n}\n\n.product-div-3 {\n  padding: 0px 10px;\n  overflow-x: scroll;\n}\n\n.title-subproduct {\n  color: #28B1FF;\n  font-size: 16px;\n  font-weight: 500;\n  padding: 10px 0px;\n}\n\n.card-title-product .ant-card-body {\n  padding: 0px;\n}\n\n.title-card-product {\n  padding: 8px;\n  background-color: #D2E1FF;\n  color: #003399;\n  font-weight: 500;\n  font-size: 18px;\n}\n\n.title-card-sub-product {\n  padding: 8px;\n  border-left: 1px solid #003399;\n  color: #003399;\n  font-weight: 500;\n  font-size: 18px;\n  background-color: #f5f8fd;\n}\n\n.video-container {\n  position: relative;\n}\n\n.share-link {\n  position: absolute;\n  left: -20px;\n  z-index: 1;\n  top: -3px;\n  background-color: #28B1FF;\n  color: white;\n  border-radius: 60px;\n  padding: 5px;\n}\n\n.arrow {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 30px;\n  height: 35px;\n  background-color: transparent;\n  color: #003399;\n  font-size: 24px;\n  text-align: center;\n  line-height: 30px;\n  cursor: pointer;\n}\n\n.left-arrow {\n  left: 0;\n  z-index: 1;\n}\n\n.right-arrow {\n  right: 0;\n  z-index: 1;\n}\n\n.video-wrapper {\n  position: relative;\n}\n\n.upload-document-width {\n  width: 60%;\n}\n\n@media screen and (max-width:600px) {\n  .upload-document-width {\n    width: 100%;\n  }\n\n  .video-width {\n    margin: 0% !important;\n  }\n\n  .table-document-head .ant-table-thead {\n    display: none;\n  }\n\n  .table-document-head .ant-table-row {\n    display: grid;\n    width: 95%;\n  }\n}\n\n@media screen and (min-width:601px) and (max-width:1000px) {\n  .upload-document-width {\n    width: 100%;\n  }\n}\n\n.total-value-amount {\n  font-size: 20px;\n  color: #003399;\n  font-weight: 500;\n}\n\n.total-value-label {\n  font-size: 18px;\n  color: darkgray;\n  font-weight: 400;\n  margin-bottom: 5px;\n}\n\n.css-c1eq84-MuiPieArcLabel-root {\n  fill: white !important;\n  font-size: 18px;\n}\n\n.css-1u0lry5-MuiChartsLegend-root {\n  display: none;\n}\n\n.view-btn {\n  color: white;\n  background-color: #003399;\n  margin-right: 20px;\n  width: 75px;\n  border-radius: 8px;\n}\n\n.modal-footer-disable .ant-modal-footer {\n  display: none !important;\n}\n\n.row-data-collection {\n  display: flex;\n  column-gap: 10px;\n  justify-content: flex-start;\n}\n\n.title-view {\n  width: 180px;\n  font-size: 18px;\n  color: darkgray;\n}\n\n.content-view {\n  font-size: 18px;\n}\n\n.upload-receipt {\n  width: 50%;\n}\n\n.upload-receipt .filetypetitle {\n  font-size: 10px;\n  color: darkgray !important;\n}\n\n.upload-receipt .anticon-upload {\n  font-size: 25px;\n}\n\n.upload-receipt button {\n  width: 225px;\n  height: 50px;\n  color: #003399;\n}\n\n:where(.css-mzwlov).ant-breadcrumb .ant-breadcrumb-separator {\n  color: white !important;\n}\n\n:where(.css-dev-only-do-not-override-42nv3w).ant-breadcrumb .ant-breadcrumb-separator {\n  color: white !important;\n}\n\n:where(.css-dev-only-do-not-override-42nv3w).ant-form-item .ant-form-item-label>label {\n  padding: 2px;\n}\n\n.verify-button-entity {\n  color: rgb(75, 214, 75);\n  background: transparent;\n  font-weight: 500;\n  border: none;\n  height: 25px;\n  display: flex;\n  align-items: center;\n}\n\n.image-web-document {\n  width: 400px;\n  height: 400px;\n}\n\n:where(.css-dev-only-do-not-override-42nv3w).ant-breadcrumb .ant-breadcrumb-separator {\n  color: white !important;\n}\n\n:where(.css-17seli4).ant-breadcrumb .ant-breadcrumb-separator {\n  color: white !important;\n}\n\n.table-wrap-view .ant-table-cell {\n  text-wrap: nowrap !important;\n}\n\n:where(.css-dev-only-do-not-override-42nv3w).ant-table-wrapper .ant-table-cell,\n:where(.css-dev-only-do-not-override-42nv3w).ant-table-wrapper .ant-table-thead>tr>th {\n  padding: 8px;\n}\n\n.todo-table-content :where(.css-dev-only-do-not-override-42nv3w).ant-table-wrapper .ant-table-cell,\n:where(.css-dev-only-do-not-override-42nv3w).ant-table-wrapper .ant-table-thead>tr>th {\n  padding: 8px;\n  text-wrap: nowrap !important;\n}\n\n.todo-table-content .ant-table-thead {\n  padding: 8px;\n  text-wrap: nowrap !important;\n}\n\n.todo-table-content .ant-table-tbody {\n  text-wrap: nowrap !important;\n}\n\n.existing-collapse .ant-collapse-header {\n  border-bottom: 1px solid lightgray;\n}\n\n.existing-collapse .ant-collapse-content {\n  background-color: white !important;\n}\n\n.title-existing-retail {\n  color: #003399;\n  font-size: 16px;\n  margin: 5px 0px;\n  font-weight: bold;\n}\n\n.button-video {\n  background-color: #003399;\n  color: white;\n  width: 50%;\n  border-radius: 10px;\n  height: 34px;\n}\n\n.button-video1 {\n  background-color: white;\n  color: #003399 !important;\n  border: 1px solid #003399;\n  width: 50%;\n  border-radius: 10px;\n  margin: 0px 5px;\n  height: 34px;\n}\n\n:where(.css-dev-only-do-not-override-m4timi).ant-modal .ant-modal-content {\n  padding: 0px !important;\n}\n\n.ant-modal-title {\n  color: #003399 !important;\n  background-color: #ebeff7 !important;\n  padding: 10px !important;\n}\n\n.ant-breadcrumb-link {\n  color: white !important;\n}\n\n:where(.css-dev-only-do-not-override-m4timi).ant-breadcrumb .ant-breadcrumb-separator {\n  color: white !important;\n}\n\n.ant-modal-content {\n  padding: 0px !important;\n}\n\n.score-align {\n  display: flex;\n  align-items: center;\n}\n\n/* .ant-tabs-tab {\n  background-color: #D2E1FF !important;\n} */\n\n.pdfContainer {\n  width: 100%;\n  height: 500px;\n  overflow-y: auto;\n}\n\n.customViewer {\n  width: 100%;\n}\n\n.customCanvas {\n  width: 100%;\n}\n\n.radio-product1 :where(.css-dev-only-do-not-override-m4timi).ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {\n  background-color: #ebf1ff !important;\n}\n\n.radio-product1 :where(.css-dev-only-do-not-override-m4timi).ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {\n  border-left: 2px solid #003399 !important;\n  border-radius: 0px !important;\n  border: none !important;\n}\n\n.radio-product1 :where(.css-dev-only-do-not-override-m4timi).ant-radio-button-wrapper {\n  border: none !important;\n}\n\n.checkmark {\n  width: 6rem !important;\n  height: 6rem !important;\n  margin: 20px;\n}\n\n.checkmark__circle {\n  stroke: rgb(114, 231, 114)\n}\n\n:where(.css-dev-only-do-not-override-m4timi).ant-drawer .ant-drawer-content {\n  border-top-right-radius: 10px;\n  border-top-left-radius: 10px;\n}\n\n:where(.css-dev-only-do-not-override-m4timi).ant-drawer .ant-drawer-header {\n  background: #ebeff7;\n  color: #003399;\n}\n\n:where(.css-dev-only-do-not-override-m4timi).ant-drawer .ant-drawer-close {\n  color: #003399;\n}\n\n:where(.css-dev-only-do-not-override-m4timi).ant-tabs-card.ant-tabs-top>.ant-tabs-nav .ant-tabs-tab,\n:where(.css-dev-only-do-not-override-m4timi).ant-tabs-card.ant-tabs-top>div>.ant-tabs-nav .ant-tabs-tab {\n  background: #ecf3ff;\n  border: 1px solid #bfcdea;\n}\n\n.ant-breadcrumb-separator {\n  color: white !important;\n}\n\n\n.video-width {\n  margin: 0% 35%;\n}\n\ninput:-webkit-autofill {\n  transition: background-color 9999s ease-in-out 0s;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
